// Initialize Portfolios Fancybox
$(function () {
  $('[data-fancybox="portfolio"]').fancybox({
    wheel: false,
    autoScale: false,
    fitToView: false,
    buttons: [
      "slideShow",
      "thumbs",
      "close"
    ],
    clickContent: function (current, event) {
      return false;
    }
  });
});

// Smooth scroll function with offset for sticky header
function smoothScroll(target, duration, offset = 80) {
  var targetElement = document.querySelector(target);
  var targetPosition = targetElement.offsetTop - offset;
  var startPosition = window.pageYOffset;
  var distance = targetPosition - startPosition;
  var startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    var timeElapsed = currentTime - startTime;
    var run = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  function ease(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  requestAnimationFrame(animation);
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  if(anchor.getAttribute("href").length > 1){
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      var target = this.getAttribute('href');
      smoothScroll(target, 1000, 130);
    });
  }
});

// Scroll to top on form submit
document.addEventListener('DOMContentLoaded', function() {
    // Function to attach the event listener to the submit button
    function attachScrollEvent() {
        const submitButton = document.querySelector('.cog-button--submit');
        if (submitButton) {
            submitButton.addEventListener('click', function(event) {
                // Scroll to the top of the page when the button is clicked
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Smooth scrolling
                });
            });

          console.log("Hi there, this works");
        }
    }

    // Set up a MutationObserver to watch for the form being added to the DOM
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                // Check if the submit button has been added
                attachScrollEvent();
            }
        });
    });

    // Start observing the document for changes
    observer.observe(document.body, {
        childList: true, // Watch for direct children being added/removed
        subtree: true    // Watch the entire document
    });
});

// Collapsible Items in pricing table

(function () {
  let slideUp = (target, duration = 500) => {
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    
    window.setTimeout(() => {
      target.style.display = "none";
      target.style.removeProperty("height");
      target.style.removeProperty("padding-top");
      target.style.removeProperty("padding-bottom");
      target.style.removeProperty("margin-top");
      target.style.removeProperty("margin-bottom");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
      //alert("!");
    }, duration);
  };
  
  let slideDown = (target, duration = 500) => {
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
  
    if (display === "none") display = "block";
  
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
    }, duration);
  };

  let rmButtons = document.querySelectorAll(".pt-load-more");

  let readMoreToggleEvent = (e) => {
    e.preventDefault();
    rmButtons.forEach((button) => {
      let hidden_div = button.closest(".pt-column").querySelector(".pt-items-hidden");

      button.classList.toggle("active");

      if (button.classList.contains("active")) {
        slideDown(hidden_div, 400);
      } else {
        slideUp(hidden_div, 400);
      }
    });
  }

  rmButtons.forEach((button) => {
    button.addEventListener("click", readMoreToggleEvent);
  });
})();